@let organization = loadedOrganization();
<div class="dialogContainer">
  @if (!organization) {
    <div>
      <h3>Loading Organization</h3>
    </div>
  }
  <form #organizationForm="ngForm">
    @if (organization) {
      <div>
        <div class="toolbar">
          <span>
            <button matButton="text" [disabled]="isBusy()" (click)="backToOrganizationMaster()">
              <span>
                <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
                <label class="buttonLabel">Back To Search</label>
              </span>
            </button>
          </span>
          <span class="spacer"></span>
          <span>
            @if (!isNew() && isAdminUser) {
              <button class="warn-button" matButton="text" [disabled]="isBusy()" (click)="openDeactivateRepDialog()">
                <span>
                  <mat-icon class="size-16">cancel</mat-icon>
                  <label class="buttonLabel">Cancel Organization</label>
                </span>
              </button>
            }
            @if (!isNew()) {
              <button matButton="text" [disabled]="isBusy()" (click)="showAddresses()">
                <span>
                  <mat-icon class="size-16">contact_mail</mat-icon>
                  <label class="buttonLabel">Addresses</label>
                </span>
              </button>
            }
            @if (!isNew()) {
              <button matButton="text" [disabled]="isBusy()" (click)="showPhones()">
                <span>
                  <mat-icon class="size-16">contact_phone</mat-icon>
                  <label class="buttonLabel">Phones</label>
                </span>
              </button>
            }
            @if (!isNew()) {
              <button matButton="text" [disabled]="isBusy()" (click)="showEmails()">
                <span>
                  <mat-icon class="size-16">email</mat-icon>
                  <label class="buttonLabel">Emails</label>
                </span>
              </button>
            }
            @if (!isNew() && isInternalOrRsm) {
              <button matButton="text" [disabled]="isBusy()" (click)="showCustomerPolicies()">
                <span>
                  <mat-icon class="size-16">recent_actors</mat-icon>
                  <label class="buttonLabel">Customer Policies</label>
                </span>
              </button>
            }
            <button matButton="text" [disabled]="!organizationForm.valid || isBusy()" (click)="save()">
              <span>
                <mat-icon class="size-16">done</mat-icon>
                <label class="buttonLabel">Save</label>
              </span>
            </button>
          </span>
        </div>
        <div class="centered">
          <h5 class="smallerMargin">Required fields are marked with an asterisk (*)</h5>
        </div>
        <table class="inputLayout">
          <tr>
            <td class="idColumnLabel"><h4><u>{{ organization.orgUnitId }}</u></h4></td>
            <td class="leftColumnLabel"><label for="descriptionInput">*Name:</label></td>
            <td class="leftColumnInput">
              <input name="descriptionInput" class="inputField standardTextBox" maxlength="30"
                id="descriptionInput" required [(ngModel)]="organization.description"
                #description="ngModel"/>
              @if (description.invalid && (description.dirty || description.touched)) {
                <span class="alert alert-danger errors"
                >Required</span>
              }
            </td>
            <td class="middleColumnLabel"><label for="organizationTypeInput">*Organization Type:</label></td>
            @if (isInternalOrRsm) {
              <td class="middleColumnInput">
                <select name="organizationTypeInput" id="organizationTypeInput" class="inputField" required
                  [(ngModel)]="organization.typeCode" #organizationTypeInput="ngModel">
                  <option value="undefined" disabled>Please Select</option>
                  @for (organizationType of organizationTypes(); track organizationType) {
                    <option [value]="organizationType.code"
                      >{{ organizationType.description }}
                    </option>
                  }
                </select>
                @if (organizationTypeInput.invalid && (organizationTypeInput.dirty || organizationTypeInput.touched)) {
                  <span class="alert alert-danger errors"
                  >Required</span>
                }
              </td>
            }
            @if (!isInternalOrRsm) {
              <td class="middleColumnInput">
                <label>{{ organization.typeDescription }}</label>
              </td>
            }
            <td class="rightColumnLabel"><label for="isActiveInput">Active:</label></td>
            <td class="rightColumnInput"><input [disabled]="!isAdminUser && !hasRole('IECCredAnalyst')"
              name="isActiveInput" type="checkbox" class="checkboxInput"
            id="isActiveInput" [(ngModel)]="organization.active"/></td>
          </tr>
          <tr>
            <td class="leftColumnLabel" colspan="2"><label for="pbcInput">Primary Contact:</label></td>
            @if (isAdminUser) {
              <td class="leftColumnInput">
                <select name="pbcInput" id="pbcInput" class="inputField" [(ngModel)]="organization.pbcId">
                  <option value="undefined" disabled>Please Select</option>
                  @for (pbc of primaryContacts(); track pbc) {
                    <option [value]="pbc.code">{{ pbc.description }}</option>
                  }
                </select>
              </td>
            }
            @if (!isAdminUser) {
              <td class="leftColumnInput">
                <label>{{ organization.pbcDescription }}</label>
              </td>
            }
            <td class="middleColumnLabel">@if (isAdminUser) {
              <label for="priceListInput">Default Price
              List:</label>
            }</td>
            <td class="middleColumnInput">
              @if (isAdminUser) {
                <select name="priceListInput" id="priceListInput" class="inputField"
                  [(ngModel)]="organization.priceListId">
                  <option value="undefined" disabled>Please Select</option>
                  @for (priceList of priceLists(); track priceList) {
                    <option [value]="priceList.code"
                      >{{ priceList.description }}
                    </option>
                  }
                </select>
              }
            </td>
            <td class="rightColumnLabel">@if (isInternalOrRsm) {
              <label for="masterOrganization">Master
              Organization:</label>
            }</td>
            <td class="rightColumnInput">
              @if (isInternalOrRsm) {
                <input name="masterOrganization" [disabled]="!isAdminUser" type="checkbox"
                  class="checkboxInput" id="masterOrganization" [(ngModel)]="organization.masterOrganization"/>
              }
            </td>
          </tr>
          <tr>
            <td class="leftColumnLabel" colspan="2"><label for="responsibilityInput">Responsibility:</label></td>
            @if (isAdminUser) {
              <td class="leftColumnInput">
                @if (responsibilities()) {
                  <select name="responsibilityInput" id="responsibilityInput"
                    class="inputField" [(ngModel)]="organization.responsibilityId">
                    <option value="undefined" disabled>Please Select</option>
                    @for (responsibility of responsibilities(); track responsibility) {
                      <option [value]="responsibility.code"
                        >{{ responsibility.description }}
                      </option>
                    }
                  </select>
                }
              </td>
            }
            @if (!isAdminUser) {
              <td class="leftColumnInput">
                <label>{{ organization.responsibilityDescription }}</label>
              </td>
            }
            <td class="middleColumnLabel">@if (isAdminUser) {
              <label for="installTypeInput">*Default Install
              Type:</label>
            }</td>
            @if (isAdminUser) {
              <td class="middleColumnInput">
                <select name="installTypeInput" id="installTypeInput" class="inputField" required
                  [(ngModel)]="organization.installCode" #installTypeInput="ngModel">
                  <option value="undefined" disabled>Please Select</option>
                  @for (installType of installTypes(); track installType) {
                    <option [value]="installType.code"
                      >{{ installType.description }}
                    </option>
                  }
                </select>
                @if (installTypeInput.invalid && (installTypeInput.dirty || installTypeInput.touched)) {
                  <span class="alert alert-danger errors"
                  >Required</span>
                }
              </td>
            }
            @if (!isAdminUser) {
              <td class="middleColumnInput">
              </td>
            }
            <td class="rightColumnLabel">@if (isInternalOrRsm) {
              <label for="isSiteInput">Site:</label>
            }</td>
            <td class="rightColumnInput">
              @if (isInternalOrRsm) {
                <input [disabled]="!isAdminUser" name="isSiteInput" type="checkbox"
                  class="checkboxInput" id="isSiteInput" [(ngModel)]="organization.site"/>
              }
            </td>
          </tr>
          <tr>
            <td class="leftColumnLabel" colspan="2"><label for="serviceRepIdInput">Service Rep:</label></td>
            @if (isAdminUser || hasRole('IECCustomerService')) {
              <td class="leftColumnInput">
                <select name="serviceRepIdInput" id="serviceRepIdInput" class="inputField"
                  [(ngModel)]="organization.serviceRepId">
                  <option value="undefined" disabled>Please Select</option>
                  @for (serviceRep of serviceReps(); track serviceRep) {
                    <option [value]="serviceRep.code"
                      >{{ serviceRep.description }}
                    </option>
                  }
                </select>
              </td>
            }
            @if (!isAdminUser && !hasRole('IECCustomerService')) {
              <td class="leftColumnInput">
                <label>{{ organization.responsibilityDescription }}</label>
              </td>
            }
            <td class="middleColumnLabel">@if (isAdminUser) {
              <label for="paymentTermsInput">*Payment Terms:</label>
            }
          </td>
          @if (isAdminUser) {
            <td class="middleColumnInput">
              <select name="paymentTermsInput" id="paymentTermsInput" class="inputField"
                [(ngModel)]="organization.paymentTermsCode" #paymentTermsInput="ngModel">
                <option value="undefined" disabled>Please Select</option>
                @for (paymentTerm of paymentTerms(); track paymentTerm) {
                  <option [value]="paymentTerm.code"
                    >{{ paymentTerm.description }}
                  </option>
                }
              </select>
              @if (paymentTermsInput.invalid && (paymentTermsInput.dirty || paymentTermsInput.touched)) {
                <span class="alert alert-danger errors"
                >Required</span>
              }
            </td>
          }
          @if (!isAdminUser) {
            <td class="middleColumnInput">
            </td>
          }
          <td class="rightColumnLabel">@if (isInternalOrRsm) {
            <label for="isCustomerInput">Customer:</label>
          }</td>
          <td class="rightColumnInput">
            @if (isInternalOrRsm) {
              <input [disabled]="!isAdminUser" name="isCustomerInput" type="checkbox"
                class="checkboxInput" id="isCustomerInput" [(ngModel)]="organization.customer"/>
            }
          </td>
        </tr>
        <tr>
          <td class="leftColumnLabel" colspan="2"><label for="appEngineerInput">Application Engineer:</label></td>
          @if (isAdminUser) {
            <td class="leftColumnInput">
              <select name="appEngineerInput" id="appEngineerInput" class="inputField"
                [(ngModel)]="organization.applicationEngineerId">
                <option value="undefined" disabled>Please Select</option>
                @for (appEngineer of applicationEngineers(); track appEngineer) {
                  <option [value]="appEngineer.code"
                    >{{ appEngineer.description }}
                  </option>
                }
              </select>
            </td>
          }
          @if (!isAdminUser) {
            <td class="leftColumnInput">
              <label>{{ organization.applicationEngineerDescription }}</label>
            </td>
          }
          <td class="middleColumnLabel"></td>
          <td class="middleColumnInput"></td>
          <td class="rightColumnLabel"></td>
          <td class="rightColumnInput"></td>
        </tr>
        <tr>
          <td class="leftColumnLabel" colspan="2"><label for="controllingOrgInput">Controlling Org:</label></td>
          @if (isInternalOrRsm) {
            <td class="leftColumnInput">
              <select name="controllingOrgInput" id="controllingOrgInput" class="inputField"
                [(ngModel)]="organization.controllingOrgId">
                <option value="undefined" disabled>Please Select</option>
                @for (org of controllingOrgs(); track org) {
                  <option [value]="org.code">{{ org.description }}</option>
                }
              </select>
            </td>
          }
          @if (!isInternalOrRsm) {
            <td class="leftColumnInput">
              <label>{{ organization.controllingOrgDescription }}</label>
            </td>
          }
          <td class="middleColumnLabel">@if (isAdminUser) {
            <label for="deliveryTermsInput">Delivery
            Terms:</label>
          }</td>
          <td class="middleColumnInput">
            @if (isAdminUser) {
              <select name="deliveryTermsInput" id="deliveryTermsInput" class="inputField"
                [(ngModel)]="organization.deliveryTermsCode">
                <option value="undefined" disabled>Please Select</option>
                @for (deliveryTerm of deliveryTerms(); track deliveryTerm) {
                  <option [value]="deliveryTerm.code"
                    >{{ deliveryTerm.description }}
                  </option>
                }
              </select>
            }
          </td>
          <td class="rightColumnLabel">@if (isInternalOrRsm) {
            <label for="isChannelInput">Channel:</label>
          }</td>
          <td class="rightColumnInput">
            @if (isInternalOrRsm) {
              <input [disabled]="!isAdminUser" name="isChannelInput" type="checkbox"
                class="checkboxInput" id="isChannelInput" [(ngModel)]="organization.channel"/>
            }
          </td>
        </tr>
        <tr>
          <td class="leftColumnLabel" colspan="2">
            @if (isInternalOrRsm) {
              <label for="prnRef">PRN Ref Code:</label>
            }
          </td>
          <td class="leftColumnInput">
            @if (isAdminUser || hasRole('IECCredAnalyst')) {
              <input name="prnRef"
                class="inputField standardTextBox" maxlength="10" id="prnRef"
                [(ngModel)]="organization.smallTextUserField4"/>
            }
            @if (isInternalOrRsm && !isAdminUser && !hasRole('IECCredAnalyst')) {
              <label>{{ organization.smallTextUserField4 }}</label>
            }
          </td>
          <td class="middleColumnLabel">@if (isAdminUser) {
            <label for="transportTerms">Transportation
            Terms:</label>
          }</td>
          <td class="middleColumnInput">
            @if (isAdminUser) {
              <select name="transportTerms" id="transportTerms" class="inputField" required
                [(ngModel)]="organization.transportationTermsCode">
                <option value="undefined" disabled>Please Select</option>
                @for (term of transportationTerms(); track term) {
                  <option [value]="term.code"
                    >{{ term.description }}
                  </option>
                }
              </select>
            }
          </td>
          <td class="rightColumnLabel">@if (isInternalOrRsm) {
            <label for="isVendorInput">Vendor:</label>
          }</td>
          <td class="rightColumnInput">
            @if (isInternalOrRsm) {
              <input [disabled]="!isAdminUser" name="isVendorInput" type="checkbox"
                class="checkboxInput" id="isVendorInput" [(ngModel)]="organization.vendor"/>
            }
          </td>
        </tr>
        <tr>
          <td class="leftColumnLabel" colspan="2">
            @if (isInternalOrRsm) {
              <label for="prmsRegion">PRMS Region:</label>
            }
          </td>
          <td class="leftColumnInput">
            @if (isAdminUser || hasRole('IECCredAnalyst')) {
              <input name="prmsRegion"
                class="inputField standardTextBox" maxlength="10" id="prmsRegion"
                [(ngModel)]="organization.smallTextUserField2"/>
            }
            @if (isInternalOrRsm && !isAdminUser && !hasRole('IECCredAnalyst')) {
              <label>{{ organization.smallTextUserField2 }}</label>
            }
          </td>
          <td class="middleColumnLabel">@if (isAdminUser) {
            <label for="freightTerms()">Freight Terms:</label>
          }</td>
          <td class="middleColumnInput">
            @if (isAdminUser) {
              <select name="freightTerms()" id="freightTerms()" class="inputField" required
                [(ngModel)]="organization.freightTermsCode">
                <option value="undefined" disabled>Please Select</option>
                @for (term of freightTerms(); track term) {
                  <option [value]="term.code">{{ term.description }}</option>
                }
              </select>
            }
          </td>
          <td class="rightColumnLabel">@if (isInternalOrRsm) {
            <label for="isValidBuying">Valid Buying Org</label>
          }
        </td>
        <td class="rightColumnInput">
          @if (isInternalOrRsm) {
            <input [disabled]="!isAdminUser" name="isValidBuying" type="checkbox"
              class="checkboxInput" id="isValidBuying" [(ngModel)]="organization.validBuyingOrg"/>
          }
        </td>
      </tr>
      <tr>
        <td class="leftColumnLabel" colspan="2">
          @if (isInternalOrRsm) {
            <label for="prmsSalesman">PRMS Salesman:</label>
          }
        </td>
        <td class="leftColumnInput">
          @if (isAdminUser || hasRole('IECCredAnalyst')) {
            <input name="prmsSalesman"
              class="inputField standardTextBox" maxlength="10" id="prmsSalesman"
              [(ngModel)]="organization.smallTextUserField3"/>
          }
          @if (isInternalOrRsm && !isAdminUser && !hasRole('IECCredAnalyst')) {
            <label>{{ organization.smallTextUserField3 }}</label>
          }
        </td>
        <td class="middleColumnLabel">@if (isAdminUser) {
          <label for="regionalTeams()">Regional Team:</label>
        }</td>
        <td class="middleColumnInput">
          @if (isAdminUser) {
            <select name="regionalTeams()" id="regionalTeams()" class="inputField" required
              [(ngModel)]="organization.classificationCode">
              <option value="undefined" disabled>Please Select</option>
              @for (team of regionalTeams(); track team) {
                <option [value]="team.code">{{ team.description }}</option>
              }
            </select>
          }
        </td>
        <td class="rightColumnLabel">@if (isInternalOrRsm) {
          <label for="isValidSelling">Valid Selling
          Org</label>
        }</td>
        <td class="rightColumnInput">
          @if (isInternalOrRsm) {
            <input [disabled]="!isAdminUser" name="isValidSelling" type="checkbox"
              class="checkboxInput" id="isValidSelling" [(ngModel)]="organization.validSellingOrg"/>
          }
        </td>
      </tr>
      <tr>
        <td class="leftColumnLabel" colspan="2">
          @if (isInternalOrRsm) {
            <label for="multiplierCode">Multiplier Code:</label>
          }
        </td>
        <td class="leftColumnInput">
          @if (isAdminUser || hasRole('IECCredAnalyst')) {
            <input name="multiplierCode"
              class="inputField standardTextBox" maxlength="5" id="multiplierCode"
              [(ngModel)]="organization.mnemonic"/>
          }
          @if (isInternalOrRsm && !isAdminUser && !hasRole('IECCredAnalyst')) {
            <label>{{ organization.mnemonic }}</label>
          }
        </td>
        <td class="middleColumnLabel">@if (isAdminUser) {
          <label for="statusCodeInput">*Status Code:</label>
        }
      </td>
      @if (isAdminUser) {
        <td class="middleColumnInput">
          <select name="statusCodeInput" id="statusCodeInput" class="inputField" required
            [(ngModel)]="organization.statusCode" #statusCodeInput="ngModel">
            <option value="undefined" disabled>Please Select</option>
            @for (status of orgStatusCodes(); track status) {
              <option [value]="status.code"
                >{{ status.description }}
              </option>
            }
          </select>
          @if (statusCodeInput.invalid && (statusCodeInput.dirty || statusCodeInput.touched)) {
            <span class="alert alert-danger errors"
            >Required</span>
          }
        </td>
      }
      @if (!isAdminUser) {
        <td class="middleColumnInput">
        </td>
      }
    </tr>
    <tr>
      <td class="leftColumnLabel" colspan="2">
        @if (isInternalOrRsm) {
          <label for="erpReference">ERP Reference:</label>
        }
      </td>
      <td class="leftColumnInput">
        @if (isAdminUser || hasRole('IECCredAnalyst')) {
          <input name="erpReference"
            class="inputField standardTextBox" maxlength="25" id="erpReference"
            [(ngModel)]="organization.erpReferenceId"/>
        }
        @if (isInternalOrRsm && !isAdminUser && !hasRole('IECCredAnalyst')) {
          <label>{{ organization.erpReferenceId }}</label>
        }
      </td>
      <td class="middleColumnLabel">@if (isAdminUser) {
        <label for="siteStatusCodeInput">Site Status:</label>
      }
    </td>
    <td class="middleColumnInput">
      @if (isAdminUser) {
        <select name="siteStatusCodeInput" id="siteStatusCodeInput" class="inputField"
          required [(ngModel)]="organization.siteStatusCode">
          <option value="undefined" disabled>Please Select</option>
          @for (status of siteStatusCodes(); track status) {
            <option [value]="status.code"
              >{{ status.description }}
            </option>
          }
        </select>
      }
    </td>
    <td colspan="2" class="leftPadded"><label>Created: {{ organization.createUser }}
    - {{ organization.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
  </tr>
  <tr>
    <td class="leftColumnLabel" colspan="2">@if (isAdminUser) {
      <label for="customerStatusInput">*Customer
      Status:</label>
    }</td>
    @if (isAdminUser) {
      <td class="leftColumnInput">
        <select name="customerStatusInput" id="customerStatusInput" class="inputField" required
          [(ngModel)]="organization.customerStatusCode" #customerStatusInput="ngModel">
          <option value="undefined" disabled>Please Select</option>
          @for (status of customerStatusCodes(); track status) {
            <option [value]="status.code"
              >{{ status.description }}
            </option>
          }
        </select>
        @if (customerStatusInput.invalid && (customerStatusInput.dirty || customerStatusInput.touched)) {
          <span class="alert alert-danger errors"
          >Required</span>
        }
      </td>
    }
    @if (!isAdminUser) {
      <td class="leftColumnInput">
      </td>
    }
    <td class="middleColumnLabel">@if (isAdminUser) {
      <label for="channelStatusInput">*Channel
      Status:</label>
    }</td>
    @if (isAdminUser) {
      <td class="middleColumnInput">
        <select name="channelStatusInput" id="channelStatusInput" class="inputField" required
          [(ngModel)]="organization.channelStatusCode" #channelStatusInput="ngModel">
          <option value="undefined" disabled>Please Select</option>
          @for (status of channelStatusCodes(); track status) {
            <option [value]="status.code"
              >{{ status.description }}
            </option>
          }
        </select>
        @if (channelStatusInput.invalid && (channelStatusInput.dirty || channelStatusInput.touched)) {
          <span class="alert alert-danger errors"
          >Required</span>
        }
      </td>
    }
    @if (!isAdminUser) {
      <td class="middleColumnInput">
      </td>
    }
    <td colspan="2" class="leftPadded"><label>Updated: {{ organization.updateUser }}
    - {{ organization.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</label></td>
  </tr>
  <tr>
    <td class="leftColumnLabel" colspan="2">
      @if (isAdminUser) {
        <label for="parentOrgInput">Parent Org:</label>
      }
    </td>
    @if (isAdminUser) {
      <td class="leftColumnInput">
        <select name="parentOrgInput" id="parentOrgInput" class="inputField"
          [(ngModel)]="organization.parentOrg">
          <option value="undefined" disabled>Please Select</option>
          @for (org of parentOrgs(); track org) {
            <option [value]="org.code">{{ org.description }}</option>
          }
        </select>
      </td>
    }
    <td class="middleColumnLabel" colspan="6"></td>
  </tr>
  <tr>
    @if (errorMessage()) {
      <td colspan="9" class="alert alert-danger errors">
        {{ errorMessage() }}
      </td>
    }
  </tr>
</table>
@if (isBusy()) {
  <span class="busyIndicator">
    <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
    <label class="busyLabel">Please Wait...</label>
  </span>
}
</div>
}
</form>
</div>
